import {SPICECLUB_DETAILS} from './SpiceClubType'


const initialState={
    UserName:10,
    Password:'',
    Role:'',
    Id:''
}

const spiceclubReducer=(state=initialState,action)=>
{   
    switch(action.type)
    {
        case SPICECLUB_DETAILS: return{
            ...state,
            UserName:state.UserName,
            Password:state.Password,
            Role:state.Role,
            Id:state.Id
        }
        default: return state
    }
}

export default spiceclubReducer;